import { AstroCityEntry } from "../../../../models/interfaces";

/**
 * Reference city list used by the "cities crossed by a line" search.
 * Ported verbatim from the standalone astrocartography reference implementation.
 * Tuple shape: [name, countryCode, latitude, longitude].
 */
const astroCities: AstroCityEntry[] = [
  ["Warszawa", "PL", 52.2297, 21.0122],
  ["Krakow", "PL", 50.0647, 19.945],
  ["Lodz", "PL", 51.7592, 19.456],
  ["Wroclaw", "PL", 51.1079, 17.0385],
  ["Poznan", "PL", 52.4064, 16.9252],
  ["Gdansk", "PL", 54.352, 18.6466],
  ["Szczecin", "PL", 53.4285, 14.5528],
  ["Bydgoszcz", "PL", 53.1235, 18.0084],
  ["Lublin", "PL", 51.2465, 22.5684],
  ["Katowice", "PL", 50.2649, 19.0238],
  ["Bialystok", "PL", 53.1325, 23.1688],
  ["Czestochowa", "PL", 50.8118, 19.1203],
  ["Rzeszow", "PL", 50.0413, 21.999],
  ["Kielce", "PL", 50.8661, 20.6286],
  ["Olsztyn", "PL", 53.7784, 20.4801],
  ["Chrzanow", "PL", 50.1358, 19.4013],
  ["Zakopane", "PL", 49.2992, 19.9496],
  ["Torun", "PL", 53.0138, 18.5984],
  ["Berlin", "DE", 52.52, 13.405],
  ["Munich", "DE", 48.1351, 11.582],
  ["Hamburg", "DE", 53.5511, 9.9937],
  ["Frankfurt", "DE", 50.1109, 8.6821],
  ["Cologne", "DE", 50.9375, 6.9603],
  ["Dresden", "DE", 51.0504, 13.7373],
  ["Prague", "CZ", 50.0755, 14.4378],
  ["Brno", "CZ", 49.1951, 16.6068],
  ["Vienna", "AT", 48.2082, 16.3738],
  ["Bratislava", "SK", 48.1486, 17.1077],
  ["Budapest", "HU", 47.4979, 19.0402],
  ["Kyiv", "UA", 50.4501, 30.5234],
  ["Lviv", "UA", 49.8397, 24.0297],
  ["Minsk", "BY", 53.9006, 27.559],
  ["Vilnius", "LT", 54.6872, 25.2797],
  ["Riga", "LV", 56.9496, 24.1052],
  ["Tallinn", "EE", 59.437, 24.7536],
  ["Moscow", "RU", 55.7558, 37.6173],
  ["St Petersburg", "RU", 59.9311, 30.3609],
  ["Bucharest", "RO", 44.4268, 26.1025],
  ["Sofia", "BG", 42.6977, 23.3219],
  ["Belgrade", "RS", 44.7866, 20.4489],
  ["Zagreb", "HR", 45.815, 15.9819],
  ["Ljubljana", "SI", 46.0569, 14.5058],
  ["Athens", "GR", 37.9838, 23.7275],
  ["Istanbul", "TR", 41.0082, 28.9784],
  ["Ankara", "TR", 39.9334, 32.8597],
  ["Rome", "IT", 41.9028, 12.4964],
  ["Milan", "IT", 45.4642, 9.19],
  ["Naples", "IT", 40.8518, 14.2681],
  ["Venice", "IT", 45.4408, 12.3155],
  ["Paris", "FR", 48.8566, 2.3522],
  ["Marseille", "FR", 43.2965, 5.3698],
  ["Lyon", "FR", 45.764, 4.8357],
  ["Madrid", "ES", 40.4168, -3.7038],
  ["Barcelona", "ES", 41.3874, 2.1686],
  ["Seville", "ES", 37.3891, -5.9845],
  ["Lisbon", "PT", 38.7223, -9.1393],
  ["London", "GB", 51.5074, -0.1278],
  ["Manchester", "GB", 53.4808, -2.2426],
  ["Edinburgh", "GB", 55.9533, -3.1883],
  ["Dublin", "IE", 53.3498, -6.2603],
  ["Amsterdam", "NL", 52.3676, 4.9041],
  ["Brussels", "BE", 50.8503, 4.3517],
  ["Zurich", "CH", 47.3769, 8.5417],
  ["Geneva", "CH", 46.2044, 6.1432],
  ["Copenhagen", "DK", 55.6761, 12.5683],
  ["Oslo", "NO", 59.9139, 10.7522],
  ["Stockholm", "SE", 59.3293, 18.0686],
  ["Helsinki", "FI", 60.1699, 24.9384],
  ["Reykjavik", "IS", 64.1466, -21.9426],
  ["Cairo", "EG", 30.0444, 31.2357],
  ["Tel Aviv", "IL", 32.0853, 34.7818],
  ["Jerusalem", "IL", 31.7683, 35.2137],
  ["Dubai", "AE", 25.2048, 55.2708],
  ["Riyadh", "SA", 24.7136, 46.6753],
  ["Tehran", "IR", 35.6892, 51.389],
  ["Baghdad", "IQ", 33.3152, 44.3661],
  ["Nairobi", "KE", -1.2921, 36.8219],
  ["Lagos", "NG", 6.5244, 3.3792],
  ["Cape Town", "ZA", -33.9249, 18.4241],
  ["Johannesburg", "ZA", -26.2041, 28.0473],
  ["Casablanca", "MA", 33.5731, -7.5898],
  ["Addis Ababa", "ET", 9.03, 38.74],
  ["Accra", "GH", 5.6037, -0.187],
  ["Delhi", "IN", 28.6139, 77.209],
  ["Mumbai", "IN", 19.076, 72.8777],
  ["Bengaluru", "IN", 12.9716, 77.5946],
  ["Kolkata", "IN", 22.5726, 88.3639],
  ["Karachi", "PK", 24.8607, 67.0011],
  ["Dhaka", "BD", 23.8103, 90.4125],
  ["Bangkok", "TH", 13.7563, 100.5018],
  ["Singapore", "SG", 1.3521, 103.8198],
  ["Jakarta", "ID", -6.2088, 106.8456],
  ["Kuala Lumpur", "MY", 3.139, 101.6869],
  ["Manila", "PH", 14.5995, 120.9842],
  ["Hanoi", "VN", 21.0278, 105.8342],
  ["Beijing", "CN", 39.9042, 116.4074],
  ["Shanghai", "CN", 31.2304, 121.4737],
  ["Hong Kong", "CN", 22.3193, 114.1694],
  ["Seoul", "KR", 37.5665, 126.978],
  ["Tokyo", "JP", 35.6762, 139.6503],
  ["Osaka", "JP", 34.6937, 135.5023],
  ["Almaty", "KZ", 43.222, 76.8512],
  ["Tashkent", "UZ", 41.2995, 69.2401],
  ["New York", "US", 40.7128, -74.006],
  ["Los Angeles", "US", 34.0522, -118.2437],
  ["Chicago", "US", 41.8781, -87.6298],
  ["Houston", "US", 29.7604, -95.3698],
  ["Miami", "US", 25.7617, -80.1918],
  ["San Francisco", "US", 37.7749, -122.4194],
  ["Seattle", "US", 47.6062, -122.3321],
  ["Washington DC", "US", 38.9072, -77.0369],
  ["Toronto", "CA", 43.6532, -79.3832],
  ["Vancouver", "CA", 49.2827, -123.1207],
  ["Mexico City", "MX", 19.4326, -99.1332],
  ["Bogota", "CO", 4.711, -74.0721],
  ["Lima", "PE", -12.0464, -77.0428],
  ["Santiago", "CL", -33.4489, -70.6693],
  ["Buenos Aires", "AR", -34.6037, -58.3816],
  ["Sao Paulo", "BR", -23.5505, -46.6333],
  ["Rio de Janeiro", "BR", -22.9068, -43.1729],
  ["Brasilia", "BR", -15.7975, -47.8919],
  ["Sydney", "AU", -33.8688, 151.2093],
  ["Melbourne", "AU", -37.8136, 144.9631],
  ["Perth", "AU", -31.9505, 115.8605],
  ["Auckland", "NZ", -36.8485, 174.7633],
];

export default astroCities;
